import ApiCall from "../../../../utils/apiCall";
import { showModal } from "../../../../actions/ui";

// Reducer
export default function reducer(state = {}, action) {
  switch (action.type) {
    case "store.customBuild.payment.isFetching":
      return { ...state, isFetching: true };

    case "store.customBuild.payment.fetchSuccess":
      return { ...state, isFetching: false, store: action.response };

    case "store.customBuild.payment.fetchError":
      return { ...state, isFetching: false };

    default:
      return state;
  }
}

// Actions
export function createPayment({ planId }) {
  return async dispatch => {
    dispatch({ type: "store.customBuild.payment.isFetching" });
    try {
      const response = await ApiCall.post("/store/custom_build/payment", {
        plan_id: planId,
      });
      dispatch(showModal("STORE_BUILDER_SUCCESS_MODAL"));
      dispatch({
        type: "store.customBuild.payment.fetchSuccess",
        response: response.json,
      });
    } catch (error) {
      dispatch({ type: "store.customBuild.payment.fetchError" });
    }
  };
}



// WEBPACK FOOTER //
// ./src/newDropshipperApp/module/store/customBuild/payment.js